<template>
    <div class="con">
<!--        <div class="th">-->
<!--            <div class="l">-->
<!--                <p class="a">{{$t('foot').text1}}</p>-->
<!--                <p class="b">-->
<!--                    {{$t('contact').text3}}<br>-->
<!--                    {{$t('contact').text4}}-->
<!--                </p>-->
<!--            </div>-->
<!--            <div class="l">-->
<!--                <p class="a">{{$t('foot').text2}}</p>-->
<!--                <p class="b">-->
<!--                    0089-574-88230892<br>-->
<!--                    mary@yourtrustit.com-->
<!--                </p>-->
<!--            </div>-->
<!--        </div>-->
    <div class="one">
    <div class="main">
        <div class="left">
            <img src="../assets/yr/logo.svg" alt="">
<!--            <p>-->
<!--                {{$t('contact').text1}}-->
<!--            </p>-->
            <p>
<!--              <span>{{$t('foot').text1}}</span>-->
                {{$t('contact').text3}}<br>
                {{$t('contact').text4}}
            </p>
            <p>
<!--                <span>{{$t('foot').text2}}</span>-->
                {{$t('foot').text7}}<br>
                {{$t('foot').text8}}<br>
                mary@yourtrustit.com
            </p>
        </div>
        <div class="right">
            <div class="r1">
                <p v-for="(item,index) in $t('list')" :key="index" @click="goto(index)">{{item}}</p>
            </div>
            <div class="r2">
                <p v-for="(item,index) in $t('navList')[1].con" :key="index" @click="goto2(index,item.CALLED,item.ID)">{{item.CALLED}}</p>
            </div>
            <div class="form">
                <p class="t1">{{$t('form').text6}}</p>
                <input class="ii" type="text" :placeholder="$t('form').text1" v-model="form.name">
                <input type="text" :placeholder="$t('form').text2" v-model="form.email">
                <textarea :placeholder="$t('form').text5" v-model="form.content"></textarea>
                <div style="text-align: center" @click="send">
                    <btn-Component :text="$t('btn2')"></btn-Component>
                </div>
            </div>
<!--         <div class="item" v-for="(item,index) in $t('navList')" :key="index">-->
<!--             <p v-for="(i,inx) in item.con" :key="inx" @click="goto(index,inx,i)">{{i}}</p>-->
<!--         </div>-->
        </div>
    </div>
    </div>
        <div class="two">
            <div class="main">
                <span>{{$t('foot').text5}}</span>
                <a href="https://www.sansg.com/">{{$t('foot').text6}}</a>
            </div>
        </div>
    </div>
</template>

<script>
    import {getProductstypeUrl2} from '../util/lang'
    import btnComponent from '../components/btn'
    import  qs from 'qs'
    export default {
        name: "foot",
        data(){
            return{
                form:{
                    name:'',
                    email:'',
                    content:''
                },
             navList:[
                 {
                     con:[
                         "ABOUT"
                     ]
                 },
                 {
                     con:[
                         "PRODUCTS"
                     ]
                 },
                 {
                     con:[
                         "QUALIFICATION"
                     ]
                 },
                 {
                     con:[
                         "NEWS"
                     ]
                 },
                 {
                     con:[
                         "CONTACT"
                     ]
                 }
             ]
            }
        },
        components:{
            btnComponent
        },
        mounted(){
            if(this.$i18n.locale==='en'){
                this.getPro('72')
            }else{
                this.getPro('84')
            }
        },
        methods:{
            send() {
                if(this.form.email==='' || this.form.name==='' || this.form.content===''){
                    this.$notify({
                        title: 'Prompt',
                        message: 'Please fill in the completed information',
                        offset: 100
                    });
                }else{
                    this.$nextTick(()=>{
                        const url ='/php/form.php'
                        this.$axios.post(url,
                            qs.stringify(
                                this.form
                            )
                        ).then(res => {
                            if(res.status==200)
                            {
                                this.$notify({
                                    title: 'Success',
                                    message: 'Submitted successfully',
                                    offset: 100
                                })
                                this.form={
                                    email:'',
                                }
                            }else{
                                this.$notify({
                                    title: 'Failure',
                                    message: 'Submission Failed',
                                    offset: 100
                                });
                            }
                        })
                    })
                }
            },
            getPro(id){
                if(this.$i18n.locale==='en'){
                    this.$t('navList')[1].con=[
                        {CALLED:"PRODUCT"}
                    ]
                }else{
                    this.$t('navList')[1].con=[
                        {CALLED:"产品中心"}
                    ]
                }
                this.$nextTick(()=>{
                    const url = `${getProductstypeUrl2(this.$i18n.locale,id)}`
                    this.$axios.get(url).then(res => {
                       res.data=res.data.slice(0,5)
                        setTimeout(()=>{
                            res.data.map((item)=>{
                                this.$t('navList')[1].con.push(item)
                            })
                        },100)

                    })
                })
            },
            goto(n){
                localStorage.setItem('index',n+1)
                if(n===0){
                    this.$router.push({path:'/'})
                }else if(n===1){
                    this.$router.push({path:'/about'})
                } else if(n===2){
                    this.$router.push({path:'/pro'})
                } else if(n===3){
                    this.$router.push({path:'/honor'})
                }else if(n===4){
                    this.$router.push({path:'/news'})
                }else{
                    this.$router.push({path:'/support'})
                }
            },
            goto2(i,t,id){
                if(i===0){
                  console.log("aa")
                } else{
                    if(this.$i18n.locale==='en'){
                        this.$router.push({path:'/proList',query:{index:i,id:id,text:t}})
                        this.$router.go(0)
                    }else{
                        this.$router.push({path:'/proList',query:{index:i,id:id,text:t}})
                        this.$router.go(0)
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    border-top: 1px solid #EBEBEB;
    .th{
        width:1000px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-bottom: 10px;
        .l{
            text-align: center;
            .a{
             font-family: Calibri;
                text-transform: uppercase;
                font-size: 30px;
            }
            .b{
                font-family: Calibri;
                font-weight: lighter;
                font-size: 14px;
                line-height: 30px;
            }
        }
    }
    .one{
        background-color: #F6F6F6;
        width:100%;
        padding: 60px 0;
        .main{
            width:80%;
            margin: 0 auto;
            display: flex;
            flex-direction: row;
            .left{
                font-family: Calibri;
                font-size: 20px;
                color:#7A7A7A;
                span{
                    color:black;
                }
                img{
                    height:100px;
                }
                p{
                    margin-block-start: 0.5em;
                    margin-left: 10px;
                    line-height: 30px;
                }
            }
            .right{
                width:60%;
                margin-left: 10%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                .r1{
                    p{
                        cursor: pointer;
                        transition: all 1s;
                        font-size: 20px;
                        color:#7A7A7A;
                    }
                    p:hover{
                        color:#F4A000;
                    }
                }
                .r2{
                    margin-left: 15%;
                    p{
                        cursor: pointer;
                        transition: all 1s;
                        font-size: 18px;
                        color:rgba(122,122,122,.8);
                    }
                    p:nth-child(1){
                        font-size: 20px;
                        color:black;
                    }
                    p:hover{
                        color:#F4A000;
                    }
                }
                .form{
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    margin-left: 10%;
                    width:40%;
                    .t1{
                        font-size: 20px;
                    }
                    input{
                        width:100%;
                        height:35px;
                        border: 1px solid #D1D1D1;
                        margin-top: 20px;
                        text-indent: 10px;
                        border-radius: 5px;
                    }
                    .ii{
                        margin-top: 0;
                    }
                    input:focus{
                        outline: none;
                    }
                    textarea{
                        width:100%;
                        margin-top: 20px;
                        height:100px;
                        text-indent: 10px;
                        border-radius: 5px;
                        resize: none;
                        border: 1px solid #D1D1D1;
                    }
                    textarea:focus{
                        outline: none;
                    }
                    div{
                        width:100%;
                        margin-top: 20px;
                    }
                }
                .item{
                    text-transform: uppercase;
                    p{
                        font-family: Calibri;
                        font-weight: lighter;
                        font-size: 14px;
                        cursor: pointer;
                        transition: all 2s;
                        color:#7A7A7A;
                        text-transform: capitalize;
                    }
                    p:first-child{
                        font-family: Calibri;
                        font-size: 20px;
                    }
                    p:hover{
                        color:#F4A000;
                    }
                }
            }
        }
    }
    .two{
        width:100%;
        background-color: #F4A000;
        padding: 30px 0;
        color:white;
        font-weight: lighter;
        font-family: Calibri;
        .main{
            width:80%;
            margin: 0 auto;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            span{
                cursor: pointer;
                transition: all 2s;
            }
            a{
                color:white;
                transition: all 2s;
            }
            span:hover{
                color:#F4A000;
            }
            a:hover{
                color:#F4A000;
            }
        }
    }
    @media screen and (max-width:450px){
        .th{
            width:90%;
            margin-left: 5%;
            flex-direction: column;
            align-items: center;
            .l{
                .a{
                    font-size: 20px;
                }
            }
        }
        .one{
            .main{
                width:90%;
                margin-left: 5%;
                .left{
                    width:100%;
                    text-align: center;
                }
                .right{
                    display: none;
                }
            }
        }
        .two{
            padding: 15px 0;
            .main{
                width:90%;
                margin-left: 5%;
                flex-direction: column;
                span{
                    display: inline-block;
                    width:100%;
                    font-size: 14px;
                    line-height: 30px;
                    text-align: center;
                }
                a{
                    font-size: 14px;
                    text-align: center;
                }
            }
        }
    }
}
</style>